import * as yup from 'yup'
import { emailValidationSchema, passwordValidationSchema } from './singleFieldsValidationSchemas'

const validationSchema = yup.object({
  email: emailValidationSchema,
  password: passwordValidationSchema,
})

export default validationSchema
